import PropTypes from "prop-types"

export const MetricPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  dataPath: PropTypes.string,
  dataGetter: PropTypes.func,
  metricIndex: PropTypes.number,
  isSticky: PropTypes.bool,
  category: PropTypes.string,
  formatter: PropTypes.func,
  isFavorite: PropTypes.bool,
  adjustedReason: PropTypes.string,
  tooltipContents: PropTypes.node,
  tooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  action: PropTypes.func,
  format: PropTypes.string,
  shouldShowTooltip: PropTypes.func,
  getTooltipText: PropTypes.func,
  delayTag: PropTypes.string,
})

export const IntradayPricingSummaryPropType = PropTypes.shape({
  pricedTodayWeightRatio: PropTypes.number.isRequired,
  pricedTodayCountRatio: PropTypes.number.isRequired,
  holdingCount: PropTypes.number.isRequired,
})
